const defaultCompanyGroups = {};
const companyGroupList = (state = defaultCompanyGroups, action) => {
  switch (action.type) {
    case 'GET_COMPANY_GROUPS_LIST_SUCCESS':
      return { ...action.companyGroupList };
    default:
      return state;
  }
};

export default companyGroupList;
